import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';
import type { IconPropsType } from './types';

export const SuccessFillIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.85355 12.1464C9.65829 11.9512 9.34171 11.9512 9.14645 12.1464C8.95118 12.3417 8.95118 12.6583 9.14645 12.8536L9.85355 12.1464ZM11.5 14.5L11.1464 14.8536C11.2458 14.9529 11.3823 15.0059 11.5227 14.9995C11.663 14.9931 11.7942 14.928 11.8841 14.8201L11.5 14.5ZM15.2174 10.8201C15.3942 10.608 15.3656 10.2927 15.1534 10.1159C14.9413 9.93911 14.626 9.96777 14.4492 10.1799L15.2174 10.8201ZM20 12.5H20.5C20.5 7.80558 16.6944 4 12 4V4.5V5C16.1421 5 19.5 8.35786 19.5 12.5H20ZM12 4.5V4C7.30558 4 3.5 7.80558 3.5 12.5H4H4.5C4.5 8.35786 7.85786 5 12 5V4.5ZM4 12.5H3.5C3.5 17.1944 7.30558 21 12 21V20.5V20C7.85786 20 4.5 16.6421 4.5 12.5H4ZM12 20.5V21C16.6944 21 20.5 17.1944 20.5 12.5H20H19.5C19.5 16.6421 16.1421 20 12 20V20.5ZM9.5 12.5L9.14645 12.8536L11.1464 14.8536L11.5 14.5L11.8536 14.1464L9.85355 12.1464L9.5 12.5ZM11.5 14.5L11.8841 14.8201L15.2174 10.8201L14.8333 10.5L14.4492 10.1799L11.1159 14.1799L11.5 14.5Z"
        fill={iconColor}
      />
    </Box>
  );
};
